<template>
  <el-table
    :data="tableData"
    highlight-current-row
    style="width: 100%"
    size="mini"
    max-height="250"
    :empty-text='emptyText'
  >
    <el-table-column type="index" width="50"> </el-table-column>
    <el-table-column
      v-for="item in columns"
      :key="item.id"
      :prop="item.prop"
      :label="item.label"
      :width="item.width"
    >
    </el-table-column>
    <el-table-column label="溯源微站" width="150" prop="name">
      <template slot-scope="scope">
        <div v-for="item in scope.row.result_trace" :key="item.name">
          {{ item.name }}
        </div>
      </template>
    </el-table-column>
    <el-table-column width="100" label="溯源详情">
      <template slot-scope="scope">
        <el-button
          type="text"
          size="mini"
          @click="exportToExcel(scope.$index, scope.row)"
          v-show="!(scope.row.result_trace[0].disabled)"
          >下载</el-button
        >
      </template>
    </el-table-column>
  </el-table>
</template>

<script>
import { pollution_analysis_columns } from "@/utils/common";
import FileSaver from "@/utils/plugins/FileSaver";
import cloneDeep from "lodash/cloneDeep";
export default {
  props: ["tableData", "gf_name",'emptyText'],
  data() {
    return {
      columns: pollution_analysis_columns,
    };
  },
  methods: {
    // handleDownLoad(inex, row) {
    //   let content = [];
    //   content[0] = `${this.gf_name}${row.para} ${row.time_start}-${row.time_end}污染详情\n`;
    //   content[1] = [
    //     `序号,微站名称,微站SN号,贡献率,最高浓度,最高局部污染指数,相对方位,距离\n`,
    //   ];
    //   console.log(inex);
    //   console.log(row);
    //   let result_trace = row.result_trace;
    //   let info_contribute;
    //   for (let i in result_trace) {
    //     let info = result_trace[i];
    //     let text = `${parseInt(i) + 1},${info.name},${info.sn},${
    //       Number(info.contribute * 100).toFixed() + "%"
    //     },${info.abs_max},${info.local_max},${info.degree},${info.distance}\n`;
    //     content.push([text]);
    //   }
    //   const file_name = `${this.gf_name}${row.para} ${row.time_start}-${row.time_end}污染详情`;
    //   let blob = new Blob(content, { type: "text/plain;charset=utf-8" });
    //   FileSaver.saveAs(blob, file_name + ".csv");
    // },
    exportToExcel(inex, row) {
      let result_trace = cloneDeep(row.result_trace);
      
      require.ensure([], () => {
        result_trace.forEach((item,index) => {
          item.contribute = Number(item.contribute * 100).toFixed() + "%";
          item.index=index+1
        });

        let title = `${this.gf_name}${row.para} ${row.time_start}-${row.time_end}污染详情\n`;
        const { export_json_to_excel } = require("@/Excel/Export2Excel.js"); // 引入文件
        const tHeader = [
          "序号",
          "微站名称",
          "微站SN号",
          "贡献率",
          "最高浓度",
          "最高局部污染指数",
          "相对方位",
          "距离(单位：千米)",
        ]; // 对应表头
        const filterVal = [
          "index",
          "name",
          "sn",
          "contribute",
          "abs_max",
          "local_max",
          "degree",
          "distance",
        ]; // table表格中对应的属性名
        const list = result_trace; // 数据JSON
        const data = this.formatJson(filterVal, list);
        export_json_to_excel(tHeader, data, title);
      });
    },
    formatJson(filterVal, jsonData) {
      return jsonData.map((v) => filterVal.map((j) => v[j]));
    },
  },
};
</script>

<style>
</style>


// WEBPACK FOOTER //
// src/components/suyuan/backInfo_table.vue